// Secure token storage utilities
const STORAGE_KEY = 'hc_session';

function encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16))));
}

function decode(str) {
  try {
    return decodeURIComponent(Array.from(atob(str), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
  } catch { return null; }
}

export function setSession(token, user) {
  const payload = JSON.stringify({ token, user, ts: Date.now() });
  sessionStorage.setItem(STORAGE_KEY, encode(payload));
}

export function getSession() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const decoded = decode(raw);
  if (!decoded) return null;
  try {
    const data = JSON.parse(decoded);
    // Auto-expire after 8 hours
    if (Date.now() - data.ts > 8 * 60 * 60 * 1000) { clearSession(); return null; }
    return data;
  } catch { return null; }
}

export function getToken() {
  return getSession()?.token || null;
}

export function getUser() {
  return getSession()?.user || null;
}

export function clearSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}
